var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0996 5H10.0996C9.26961 5 8.59961 5.67 8.59961 6.5V41.5C8.59961 42.33 9.26961 43 10.0996 43H39.0996C39.9296 43 40.5996 42.33 40.5996 41.5V6.5C40.5996 5.67 39.9296 5 39.0996 5ZM23.0996 9.5C23.0996 8.67 23.7696 8 24.5996 8C25.4296 8 26.0996 8.67 26.0996 9.5V10.5C26.0996 11.33 25.4296 12 24.5996 12C23.7696 12 23.0996 11.33 23.0996 10.5V9.5ZM23.0996 16.5C23.0996 15.67 23.7696 15 24.5996 15C25.4296 15 26.0996 15.67 26.0996 16.5V17.5C26.0996 18.33 25.4296 19 24.5996 19C23.7696 19 23.0996 18.33 23.0996 17.5V16.5ZM33.3596 34H26.2596L26.1696 36.39L29.8296 37.72C30.2896 37.89 30.5996 38.33 30.5996 38.82C30.5996 39.47 30.0696 40 29.4196 40H19.7796C19.1296 40 18.5996 39.47 18.5996 38.82C18.5996 38.33 18.9096 37.89 19.3696 37.72L23.0296 36.39L22.9396 34H15.8396C15.1496 34 14.5996 33.45 14.5996 32.76C14.5996 32.3 14.8596 31.87 15.2796 31.66L22.7396 27.93L22.5996 24C22.5996 22.9 23.4996 22 24.5996 22C25.6996 22 26.5996 22.9 26.5996 24L26.4596 27.93L33.9196 31.66C34.3396 31.87 34.5996 32.3 34.5996 32.76C34.5996 33.45 34.0496 34 33.3596 34Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunway);
export default __webpack_public_path__ + "static/media/runway.842df0df1fd4edad7490c1fe0c51f5f5.svg";
export { ForwardRef as ReactComponent };